module.exports = __webpack_public_path__ + "static/media/clients-03.a7002e78.svg";